var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg003Notes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_127_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M21.094,31.5C17.438,29.199,15,25.139,15,20.5c0-4.639,2.438-8.699,6.094-11 H10.975C10.99,9.665,11,9.831,11,10c0,3.038-2.463,5.5-5.5,5.5c-0.169,0-0.335-0.01-0.5-0.025v10.05 C5.165,25.51,5.331,25.5,5.5,25.5c3.037,0,5.5,2.462,5.5,5.5c0,0.169-0.01,0.335-0.025,0.5H21.094z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_146_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M50.5,15.5c-3.038,0-5.5-2.462-5.5-5.5c0-0.169,0.01-0.335,0.025-0.5H34.906 C38.561,11.801,41,15.861,41,20.5c0,4.639-2.439,8.699-6.094,11h10.119C45.01,31.335,45,31.169,45,31c0-3.038,2.462-5.5,5.5-5.5 c0.169,0,0.335,0.01,0.5,0.025v-10.05C50.835,15.49,50.669,15.5,50.5,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_145_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M5.5,12.5C4.121,12.5,3,11.379,3,10s1.121-2.5,2.5-2.5C6.879,7.5,8,8.621,8,10 S6.879,12.5,5.5,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_144_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M50.5,12.5c-1.379,0-2.5-1.121-2.5-2.5s1.121-2.5,2.5-2.5 c1.379,0,2.5,1.121,2.5,2.5S51.879,12.5,50.5,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M5.5,33.5C4.121,33.5,3,32.379,3,31c0-1.379,1.121-2.5,2.5-2.5 C6.879,28.5,8,29.621,8,31C8,32.379,6.879,33.5,5.5,33.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M50.5,33.5c-1.379,0-2.5-1.121-2.5-2.5c0-1.379,1.121-2.5,2.5-2.5 c1.379,0,2.5,1.121,2.5,2.5C53,32.379,51.879,33.5,50.5,33.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    style: {
      fill: "#6E8C61"
    },
    d: "M22,8.975c-4.157,2.169-7,6.512-7,11.526c0,5.013,2.843,9.357,7,11.525V8.975z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_140_",
    style: {
      fill: "#6E8C61"
    },
    d: "M34,8.975v23.051c4.157-2.168,7-6.512,7-11.525C41,15.486,38.157,11.144,34,8.975"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_139_",
    y: 48.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_138_",
    x: 34,
    y: 48.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_137_",
    y: 45.5,
    style: {
      fill: "#546949"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_136_",
    x: 34,
    y: 45.5,
    style: {
      fill: "#546949"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_135_",
    y: 42.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_134_",
    x: 34,
    y: 42.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_133_",
    y: 39.5,
    style: {
      fill: "#546949"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_132_",
    x: 34,
    y: 39.5,
    style: {
      fill: "#546949"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_131_",
    y: 36.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_130_",
    x: 34,
    y: 36.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_129_",
    x: 22,
    y: 4.5,
    style: {
      fill: "#D1D4D2"
    },
    width: 12,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_128_",
    x: 22,
    y: 36.5,
    style: {
      fill: "#A5A5A4"
    },
    width: 12,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_126_",
    y: 4.5,
    style: {
      fill: "#6E8C61"
    },
    width: 56,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_105_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M21.094,31.5C17.438,29.199,15,25.139,15,20.5c0-4.639,2.438-8.699,6.094-11 H10.975C10.99,9.665,11,9.831,11,10c0,3.038-2.463,5.5-5.5,5.5c-0.169,0-0.335-0.01-0.5-0.025v10.05 C5.165,25.51,5.331,25.5,5.5,25.5c3.037,0,5.5,2.462,5.5,5.5c0,0.169-0.01,0.335-0.025,0.5H21.094z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_124_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M50.5,15.5c-3.038,0-5.5-2.462-5.5-5.5c0-0.169,0.01-0.335,0.025-0.5H34.906 C38.561,11.801,41,15.861,41,20.5c0,4.639-2.439,8.699-6.094,11h10.119C45.01,31.335,45,31.169,45,31c0-3.038,2.462-5.5,5.5-5.5 c0.169,0,0.335,0.01,0.5,0.025v-10.05C50.835,15.49,50.669,15.5,50.5,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_123_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M5.5,12.5C4.121,12.5,3,11.379,3,10s1.121-2.5,2.5-2.5C6.879,7.5,8,8.621,8,10 S6.879,12.5,5.5,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_122_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M50.5,12.5c-1.379,0-2.5-1.121-2.5-2.5s1.121-2.5,2.5-2.5 c1.379,0,2.5,1.121,2.5,2.5S51.879,12.5,50.5,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M5.5,33.5C4.121,33.5,3,32.379,3,31c0-1.379,1.121-2.5,2.5-2.5 C6.879,28.5,8,29.621,8,31C8,32.379,6.879,33.5,5.5,33.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    style: {
      fill: "#E9E8D3"
    },
    d: "M50.5,33.5c-1.379,0-2.5-1.121-2.5-2.5c0-1.379,1.121-2.5,2.5-2.5 c1.379,0,2.5,1.121,2.5,2.5C53,32.379,51.879,33.5,50.5,33.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    style: {
      fill: "#6E8C61"
    },
    d: "M22,8.975c-4.157,2.169-7,6.512-7,11.526c0,5.013,2.843,9.357,7,11.525V8.975z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_118_",
    style: {
      fill: "#6E8C61"
    },
    d: "M34,8.975v23.051c4.157-2.168,7-6.512,7-11.525C41,15.486,38.157,11.144,34,8.975"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_117_",
    y: 48.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_116_",
    x: 34,
    y: 48.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_115_",
    y: 45.5,
    style: {
      fill: "#546949"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_114_",
    x: 34,
    y: 45.5,
    style: {
      fill: "#546949"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_113_",
    y: 42.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_112_",
    x: 34,
    y: 42.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_111_",
    y: 39.5,
    style: {
      fill: "#546949"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_110_",
    x: 34,
    y: 39.5,
    style: {
      fill: "#546949"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_109_",
    y: 36.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_108_",
    x: 34,
    y: 36.5,
    style: {
      fill: "#607B53"
    },
    width: 22,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_107_",
    x: 22,
    y: 4.5,
    style: {
      fill: "#D1D4D2"
    },
    width: 12,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_106_",
    x: 22,
    y: 36.5,
    style: {
      fill: "#A5A5A4"
    },
    width: 12,
    height: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg003Notes);
export default __webpack_public_path__ + "static/media/003-notes.4073be03801b41f16ac8e19912b6e3f9.svg";
export { ForwardRef as ReactComponent };